"use client";
import { useSyncExternalStore } from "react";
const ABOVE_MD_QUERY = '(min-width: 768px)';
function subscribeAboveMd(callback) {
    const mql = globalThis.window?.matchMedia?.(ABOVE_MD_QUERY);
    if (!mql) return ()=>{};
    mql.addEventListener('change', callback);
    return ()=>mql.removeEventListener('change', callback);
}
function getAboveMdSnapshot() {
    return globalThis.window?.matchMedia?.(ABOVE_MD_QUERY)?.matches ?? false;
}
function getAboveMdServerSnapshot() {
    return true;
}
function useResponsiveDrawerDirection(direction, isInsetActive) {
    const isAboveMd = useSyncExternalStore(subscribeAboveMd, getAboveMdSnapshot, getAboveMdServerSnapshot);
    if ('left' === direction || 'right' === direction) {
        const effectiveAboveMd = isInsetActive ?? isAboveMd;
        return effectiveAboveMd ? direction : 'bottom';
    }
    return direction;
}
export { useResponsiveDrawerDirection };
